import { defineMessages } from 'react-intl';

export default defineMessages({
    claimInformation: {
        id: 'pe.fnol.common.views.fnol.Claim Information',
        defaultMessage: 'Claim Information'
    },
    selectPolcicy: {
        id: 'pe.fnol.wizard.steps.Select Policy',
        defaultMessage: 'Select Policy'
    },
    additionalInformation: {
        id: 'pe.fnol.wizard.steps.Additional Information',
        defaultMessage: 'Additional Information'
    },
    searchCriteria: {
        id: 'pe.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.',
    },
    selectPolicy: {
        id: 'pe.fnol.common.views.policy-select-policyholder.Select A Policy',
        defaultMessage: 'Select A Policy',
    },
    lossInformation: {
        id: 'pe.fnol.common.views.policy-select-policyholder.Loss Information',
        defaultMessage: 'Loss Information {policyNumber}'
    },
    searchingPolicies: {
        id: 'pe.fnol.common.views.policy-select-policyholder.Searching for your policies...',
        defaultMessage: 'Searching for your policies...'
    },
    policyNotFoundMessage: {
        id: 'pe.fnol.common.views.policy-select-producer.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    whenLossOccur: {
        id: 'pe.fnol.common.directives.loss-date-input.When did loss occur?',
        defaultMessage: 'When did loss occur?'
    },
    fnolSummaryHeader: {
        id: 'pe.fnol.wizard.step.Summary',
        defaultMessage: 'Summary'
    },
    fnolReviewInformation: {
        id: 'pe.fnol.common.views.summary.Please review the following information before submitting:',
        defaultMessage: 'Please review the following information before submitting:'
    },
    fnolPolicyNumber: {
        id: 'pe.fnol.common.views.summary.Policy Number',
        defaultMessage: 'Policy Number'
    },
    fnolTypeOfIncident: {
        id: 'pe.fnol.common.views.summary.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    fnolSummaryWhen: {
        id: 'pe.fnol.common.views.summary.When',
        defaultMessage: 'When'
    },
    fnolSummaryWhere: {
        id: 'pe.fnol.common.views.summary.Where',
        defaultMessage: 'Where'
    },
    fnolSummaryContactPerson: {
        id: 'pe.fnol.common.views.summary.Contact Person',
        defaultMessage: 'Contact Person'
    },
    fnolRepairFacility: {
        id: 'pe.fnol.common.views.summary.Repair Facility',
        defaultMessage: 'Repair Facility'
    },
    fnolNoRepairRequested: {
        id: 'pe.fnol.common.views.summary.No repair requested',
        defaultMessage: 'No repair requested'
    },
    fnolNoteToAdjuter: {
        id: 'pe.fnol.common.views.summary.Note to Adjuster',
        defaultMessage: 'Note to Adjuster'
    },
    fnolEdit: {
        id: 'pe.fnol.common.views.summary.Edit',
        defaultMessage: 'Edit'
    },
    fnolDelete: {
        id: 'pe.fnol.common.views.summary.Delete',
        defaultMessage: 'Delete'
    },
    fnolAddNoteToAdjuster: {
        id: 'pe.fnol.common.views.summary.Add a Note to the Adjuster',
        defaultMessage: 'Add a Note to the Adjuster'
    },
    fnolSummaryPara: {
        id: 'pe.fnol.common.views.summary.This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.',
        defaultMessage: 'This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.'
    },
    dialogAddNoteToAdjuster: {
        id: 'pe.fnol.common.views.note-dialog.Add a Note to the Adjuster',
        defaultMessage: 'Add a Note to the Adjuster'
    },
    dialogSubject: {
        id: 'pe.fnol.common.views.note-dialog.Subject',
        defaultMessage: 'Subject'
    },
    dialogNote: {
        id: 'pe.fnol.common.views.note-dialog.Note',
        defaultMessage: 'Note'
    },
    dialogCancel: {
        id: 'pe.fnol.common.views.note-dialog.Cancel',
        defaultMessage: 'Cancel'
    },
    dialogOk: {
        id: 'pe.fnol.common.views.note-dialog.OK',
        defaultMessage: 'Ok'
    },
    primaryContactDetails: {
        id: 'pe.fnol.common.views.main-contact.Primary Contact Details',
        defaultMessage: 'Primary Contact Details'
    },
    verifyContactInformation: {
        id: 'pe.fnol.common.views.main-contact.Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.',
        defaultMessage: 'Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.'
    },
    contactDetailsWizardStep: {
        id: 'pe.fnol.wizard.step.Contact Details',
        defaultMessage: 'Contact Details'
    },
    commonContactHeader: {
        id: 'pe.fnol.common.views.main-contact.Contact',
        defaultMessage: 'Contact'
    },
    commonContactEmailHeader: {
        id: 'pe.fnol.common.views.main-contact.Email',
        defaultMessage: 'Email'
    },
    CLPrimaryContactHeader: {
        id: 'pe.fnol.common.views.contact-details.Primary Contact',
        defaultMessage: 'Primary Insured Contact'
    },
    GLCPPrimaryContactHeader: {
        id: 'pe.fnol.common.views.contact-details.Policyholder Contact',
        defaultMessage: 'Policyholder Contact'
    },
    PLPrimaryContactHeader: {
        id: 'pe.fnol.common.views.contact-details.Primary Insured Contact',
        defaultMessage: 'Primary Insured Contact'
    },
    wizardTitleAdditionalInformation: {
        id: 'pe.fnol.wizard.step.Additional Information',
        defaultMessage: 'Additional Information'
    },
    fnolSupportingInformation: {
        id: 'pe.fnol.common.views.more-info.Supporting Information',
        defaultMessage: 'Supporting Information'
    },
    fnolAddMoreInfo: {
        id: 'pe.fnol.common.views.more-info.Add photos or documents that are relevant to the incident and may help with the claim.',
        defaultMessage: 'Add photos or documents that are relevant to the incident and may help with the claim.'
    },
    fnolWitnessesOtherParties: {
        id: 'pe.fnol.common.views.more-info.Witnesses or Other Parties',
        defaultMessage: 'Witnesses or Other Parties'
    },
    fnolAddPerson: {
        id: 'pe.fnol.common.views.more-info.Add Person',
        defaultMessage: 'Add Person'
    },
    fnolAnotherPerson: {
        id: 'pe.fnol.common.views.more-info.Another person',
        defaultMessage: 'Another person'
    },
    fnolMetropolitanReports: {
        id: 'pe.fnol.common.views.more-info.Add Law Enforcement of Responding Agency Officer',
        defaultMessage: 'Add Law Enforcement of Responding Agency Officer'
    },
    fnolPolicyReports: {
        id: 'pe.fnol.common.views.more-info.Add Policy Reports',
        defaultMessage: 'Add Police Reports'
    },
    fnolName: {
        id: 'pe.fnol.common.views.more-info.Name',
        defaultMessage: 'Name'
    },
    fnoReportNo: {
        id: 'pe.fnol.common.views.more-info.Report No',
        defaultMessage: 'Report No'
    },
    fnolFirstName: {
        id: 'pe.fnol.common.views.more-info.First name',
        defaultMessage: 'First Name'
    },
    fnolLastName: {
        id: 'pe.fnol.common.views.more-info.Last name',
        defaultMessage: 'Last Name'
    },
    fnolInvolvement: {
        id: 'pe.fnol.common.views.more-info.Involvement',
        defaultMessage: 'Involvement'
    },
    fnolPhoneNumber: {
        id: 'pe.fnol.common.views.more-info.Phone number',
        defaultMessage: 'Phone number'
    },
    fnolInjured: {
        id: 'pe.fnol.common.views.more-info.Injured',
        defaultMessage: 'Injured'
    },
    fnolRemoveUploadedDocument: {
        id: 'pe.platform.widgets.fileupload.templates.Are you sure you want to remove:',
        defaultMessage: 'Are you sure you want to remove: {documentName}?'
    },
    fnolRemove: {
        id: 'pe.fnol.common.views.more-info.Remove',
        defaultMessage: 'Remove'
    },
    fnolYes: {
        id: 'pe.fnol.common.controllers.MoreInfoCtrl.Yes',
        defaultMessage: 'Yes'
    },
    fnolNo: {
        id: 'pe.fnol.common.controllers.MoreInfoCtrl.No',
        defaultMessage: 'No'
    },
    otherPerson: {
        id: 'pe.fnol.common.controllers.MainContactCtrl.Other Person',
        defaultMessage: 'Other Person'
    },
    addNewContact: {
        id: 'pe.fnol.common.controllers.MainContactCtrl.Add new contact',
        defaultMessage: 'Add new contact'
    },
    newContact: {
        id: 'pe.fnol.common.controllers.MainContactCtrl.New Contact',
        defaultMessage: 'New Contact'
    },
    fnolDetailedPolicyNumber: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Policy Number',
        defaultMessage: 'Policy Number'
    },
    fnolDetailedInsured: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Insured',
        defaultMessage: 'Insured'
    },
    fnolDetailedAddress: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Address',
        defaultMessage: 'Address'
    },
    fnolDetailedType: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Type',
        defaultMessage: 'Type'
    },
    fnolDetailedEffective: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Effective',
        defaultMessage: 'Effective'
    },
    fnolDetailedExpires: {
        id: 'pe.fnol.common.directives.policy-search-result-detailed.Expires',
        defaultMessage: 'Expires'
    },
    successfullySubmitted: {
        id: 'pe.fnol.common.views.confirmation.Claim was successfully submitted',
        defaultMessage: 'Claim was successfully submitted'
    },
    confirmationThankMessage: {
        id: 'pe.fnol.common.views.confirmation.Thank you for submitting a claim. Our claim team will be in contact shortly.',
        defaultMessage: 'Thank you for submitting a claim. Our claim team will contact you within the next business day.'
    },
    referenceNumber: {
        id: 'pe.fnol.common.views.confirmation.Claim Reference number',
        defaultMessage: 'Claim number { num }'
    },
    foundationInsurance: {
        id: 'pe.fnol.common.views.confirmation.Kind regards, Foundation Insurance',
        defaultMessage: 'Kind regards, Foundation Insurance'
    },
    printConfirmation: {
        id: 'pe.fnol.common.views.confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    fnolSaveandExit: {
        id: 'pe.fnol.wizard.Save and Exit',
        defaultMessage: 'Save and Exit'
    },
    fnolSubmitClaim: {
        id: 'pe.fnol.common.views.summary.Submit My Claim Now',
        defaultMessage: 'Submit Claim'
    },
    fnolSubmitClaimShort: {
        id: 'pe.fnol.common.views.summary.Submit',
        defaultMessage: 'Submit'
    },
    fnolNoteErrorHead: {
        id: 'pe.fnol.common.controllers.SummaryCtrl.Note Error Head',
        defaultMessage: 'Note submission failed'
    },
    fnolNoteErrorMessage: {
        id: 'pe.fnol.common.controllers.SummaryCtrl.Note Error Message',
        defaultMessage: 'Note cannot be processed at this time. '
    },
    fnolSubmitClaimDetails: {
        id: 'pe.fnol.common.config.FlowConfig.Submitting claim details...',
        defaultMessage: 'Submitting claim details...'
    },
    fnolErrorSubmitClaimTitle: {
        id: 'pe.fnol.common.config.FlowConfig.Error submitting claim',
        defaultMessage: 'Error submitting claim'
    },
    fnolErrorSubmitClaimMessage: {
        id: 'pe.fnol.common.config.FlowConfig.An error occurred attempting to submit the claim.',
        defaultMessage: 'An error occurred attempting to submit the claim.'
    },
    fnolSaveDraftErrorTitle: {
        id: 'pe.fnol.common.config.FlowConfig.Unable to save draft claim information',
        defaultMessage: 'Unable to save draft claim information'
    },
    fnolSaveDraftErrorMessage: {
        id: 'pe.fnol.common.config.FlowConfig.An error occurred while attempting to save the claim submission.',
        defaultMessage: 'An error occurred while attempting to save the claim submission.'
    },
    fnolSaveDraftClaim: {
        id: 'pe.fnol.common.config.FlowConfig.Saving draft claim details...',
        defaultMessage: 'Saving draft claim details...'
    },
    generalCreateDraftErrorTitle: {
        id: 'pe.fnol.general.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    generalCreateDraftErrorMessage: {
        id: 'pe.fnol.general.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    generalCreateDraftClaim: {
        id: 'pe.fnol.general.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    wizardTypeOfIncident: {
        id: 'pe.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    generalWizardTypeOfIncident: {
        id: 'pe.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    wizardLossType: {
        id: 'pe.fnol.wizard.step.general.Loss Type',
        defaultMessage: 'Loss Type'
    },
    wizardTitleWhere: {
        id: 'pe.fnol.wizard.step.general.Where',
        defaultMessage: 'Where'
    },
    generalWasAnyoneInjured: {
        id: 'pe.fnol.general.views.what.Was anyone injured?',
        defaultMessage: 'Was anyone injured?'
    },
    generalAddAnInjured: {
        id: 'pe.fnol.general.views.what.Add an injured...',
        defaultMessage: 'Add an injured...'
    },
    generalFirstName: {
        id: 'pe.fnol.general.views.what.First Name',
        defaultMessage: 'First Name'
    },
    generalLastName: {
        id: 'pe.fnol.general.views.what.Last Name',
        defaultMessage: 'Last Name'
    },
    generalFirstNameKanji: {
        id: 'pe.fnol.general.views.what.First Name Kanji',
        defaultMessage: 'First Name Kanji'
    },
    generalLastNameKanji: {
        id: 'pe.fnol.general.views.what.Last Name Kanji',
        defaultMessage: 'Last Name Kanji'
    },
    generalInjuryDescription: {
        id: 'pe.fnol.general.views.what.Description',
        defaultMessage: 'Description'
    },
    generalInjured: {
        id: 'pe.fnol.general.views.what.Injured',
        defaultMessage: 'Injured #{injuredIndex}'
    },
    generalRemoveInjuredPopupTitle: {
        id: 'pe.fnol.general.views.what.modal.Remove Injured',
        defaultMessage: 'Remove Injured'
    },
    generalRemoveInjuredPopupMessage: {
        id: 'pe.fnol.general.views.what.modal.Are you sure you want to remove Injured #{injuredIndex}?',
        defaultMessage: 'Are you sure you want to remove Injured #{injuredIndex}?',
    },
    generalRemoveInjuredPopupRemoveButton: {
        id: 'pe.fnol.general.views.what.modal.Remove',
        defaultMessage: 'Remove'
    },
    generalDescribeWhatHappened: {
        id: 'pe.fnol.general.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    generalLossCause: {
        id: 'pe.fnol.general.views.what.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    generalSelectLossCause: {
        id: 'pe.fnol.general.views.what.Select Loss Cause',
        defaultMessage: 'Select Loss Cause'
    },
    generalIndicateWhoOrWhat: {
        id: 'pe.fnol.general.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    generalDescribeDamage: {
        id: 'pe.fnol.general.views.what.Describe damage',
        defaultMessage: 'Describe damage'
    },
    generalListWhatWasDamaged: {
        id: 'pe.fnol.general.views.what.List what was damaged or lost during the incident, such as structural damage or office equipment.',
        defaultMessage: 'List what was damaged or lost during the incident, such as structural damage or office equipment.'
    },
    generalDescribeInjuries: {
        id: 'pe.fnol.general.views.what.Describe injuries if any',
        defaultMessage: 'Describe injuries if any'
    },
    generalTypeOfIncidentDelete: {
        id: 'pe.fnol.wizard.tooltip.Delete',
        defaultMessage: 'Delete'
    },
    cancelModalMessage: {
        id: 'pe.fnol.common.config.FlowConfig.The information you entered will not be saved.',
        defaultMessage: 'The information you entered will not be saved.'
    },
    saveAndExitModalTitle: {
        id: 'pe.fnol.common.config.FlowConfig.Save and Exit?',
        defaultMessage: 'Save and Exit?'
    },
    saveAndExitModalMessage: {
        id: 'pe.fnol.common.config.FlowConfig.We will save the information you have entered up to this point as a draft claim.',
        defaultMessage: 'We will save the information you have entered up to this point as a draft claim. \n\nThe reference number of your draft claim is not an official claim number. Once you submit the claim at the end of this process, we will provide you with an official claim number. '
    },
    policyChangeModalTitle: {
        id: 'pe.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Title',
        defaultMessage: 'Policy change'
    },
    policyChangeModalMessage: {
        id: 'pe.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Content',
        defaultMessage: 'You have selected a new policy for this claim. The data you have entered for this claim will be lost.'
    },
    noPolicyFoundMessage: {
        id: 'pe.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    changePolicyButtonlabel: {
        id: 'pe.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Option',
        defaultMessage: 'Change Policy'
    },
    fnolMessagePopupYes: {
        id: 'pe.fnol.common.config.FlowConfig.Yes',
        defaultMessage: 'Yes'
    },
    fnolMessagePopupCancel: {
        id: 'pe.fnol.common.config.FlowConfig.Cancel',
        defaultMessage: 'Cancel'
    },
    fnolUnnamed: {
        id: 'pe.fnol.common.model.Unnamed',
        defaultMessage: 'Unnamed'
    },
    fnolBackToHome: {
        id: 'pe.fnol.common.views.confirmation.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    fnolBackToClaims: {
        id: 'pe.fnol.common.views.confirmation.Back to claims',
        defaultMessage: 'Back to claims'
    },
    province: {
        id: 'pe.fnol.common.contact-address-details.Province',
        defaultMessage: 'Province'
    },
    postalCode: {
        id: 'pe.fnol.common.contact-address-details.Postal Code',
        defaultMessage: 'Postal Code'
    },
    state: {
        id: 'pe.fnol.common.contact-address-details.State',
        defaultMessage: 'State'
    },
    zipCode: {
        id: 'pe.fnol.common.contact-address-details.ZIP Code',
        defaultMessage: 'ZIP Code'
    }
});
